export const webtoonCategories = [
  { slug: "all", name: "全部", icon: "ri-apps-line" },
  { slug: "romance", name: "恋爱", icon: "ri-heart-line" },
  { slug: "action", name: "动作", icon: "ri-flashlight-line" },
  { slug: "fantasy", name: "奇幻", icon: "ri-magic-line" },
  { slug: "thriller", name: "悬疑", icon: "ri-search-eye-line" },
  { slug: "comedy", name: "搞笑", icon: "ri-emotion-laugh-line" },
  { slug: "drama", name: "剧情", icon: "ri-film-line" },
  { slug: "horror", name: "恐怖", icon: "ri-ghost-line" },
  { slug: "slice-of-life", name: "日常", icon: "ri-sun-line" },
];

export interface WebtoonChapter {
  id: number;
  title: string;
  number: number;
  date: string;
}

export interface Webtoon {
  id: number;
  title: string;
  author: string;
  category: string;
  cover: string;
  description: string;
  rating: number;
  views: string;
  status: "连载中" | "已完结";
  tags: string[];
  chapters: WebtoonChapter[];
  featured?: boolean;
  latest?: boolean;
}

export const webtoons: Webtoon[] = [
  {
    id: 1,
    title: "星辰陨落之夜",
    author: "金明洙",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20style%20illustration%20of%20a%20mysterious%20girl%20with%20long%20silver%20hair%20standing%20under%20a%20starry%20night%20sky%20magical%20sparkles%20around%20her%20soft%20dreamy%20art%20style%20with%20clean%20lines%20and%20vibrant%20colors%20fantasy%20theme%20digital%20art%20manhwa%20cover%20style&width=400&height=560&seq=webtoon-cover-01&orientation=portrait",
    description: "在一个被星辰之力支配的世界里，少女艾琳意外获得了操控星辰的能力。然而这个能力却引来了各方势力的觊觎。为了保护身边的人，她必须踏上一条充满未知与危险的旅程，揭开星辰陨落背后的真相。在这个奇幻世界中，友情、爱情与背叛交织，每一个选择都可能改变命运的轨迹。",
    rating: 9.5,
    views: "1280万",
    status: "连载中",
    tags: ["奇幻", "冒险", "成长"],
    featured: true,
    chapters: [
      { id: 101, title: "第1话 - 星之觉醒", number: 1, date: "2024-06-01" },
      { id: 102, title: "第2话 - 隐藏在黑暗中的目光", number: 2, date: "2024-06-08" },
      { id: 103, title: "第3话 - 命运的邂逅", number: 3, date: "2024-06-15" },
      { id: 104, title: "第4话 - 初次试炼", number: 4, date: "2024-06-22" },
      { id: 105, title: "第5话 - 月下的誓言", number: 5, date: "2024-06-29" },
      { id: 106, title: "第6话 - 背叛的序章", number: 6, date: "2024-07-06" },
      { id: 107, title: "第7话 - 星辰之力", number: 7, date: "2024-07-13" },
      { id: 108, title: "第8话 - 暗影逼近", number: 8, date: "2024-07-20" },
    ],
  },
  {
    id: 2,
    title: "甜蜜陷阱",
    author: "李智慧",
    category: "romance",
    cover: "https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20webtoon%20style%20illustration%20of%20a%20handsome%20young%20man%20and%20a%20beautiful%20woman%20sharing%20a%20tender%20moment%20cherry%20blossom%20petals%20falling%20around%20them%20soft%20pink%20and%20warm%20color%20palette%20clean%20manhwa%20art%20style%20romantic%20atmosphere&width=400&height=560&seq=webtoon-cover-02&orientation=portrait",
    description: "普通上班族韩素希在一次意外中救了集团总裁的儿子。为了报答救命之恩，总裁提出了一份特殊的契约——假扮他儿子的女友三个月。本以为只是简单的交易，却在朝夕相处中逐渐产生了真感情。但这段始于谎言的关系，能否承受真相的重量？当契约到期的那一天来临，他们又该如何抉择？",
    rating: 9.2,
    views: "2150万",
    status: "连载中",
    tags: ["恋爱", "都市", "契约恋爱"],
    featured: true,
    chapters: [
      { id: 201, title: "第1话 - 意外相遇", number: 1, date: "2024-05-15" },
      { id: 202, title: "第2话 - 契约开始", number: 2, date: "2024-05-22" },
      { id: 203, title: "第3话 - 心动的信号", number: 3, date: "2024-05-29" },
      { id: 204, title: "第4话 - 假戏真做", number: 4, date: "2024-06-05" },
      { id: 205, title: "第5话 - 不速之客", number: 5, date: "2024-06-12" },
      { id: 206, title: "第6话 - 彼此的真心", number: 6, date: "2024-06-19" },
    ],
  },
  {
    id: 3,
    title: "暗夜追踪者",
    author: "朴志勋",
    category: "thriller",
    cover: "https://readdy.ai/api/search-image?query=A%20thriller%20Korean%20webtoon%20style%20illustration%20of%20a%20detective%20in%20a%20dark%20alley%20at%20night%20holding%20a%20flashlight%20mysterious%20silhouette%20in%20the%20background%20rainy%20atmosphere%20with%20neon%20reflections%20dramatic%20lighting%20noir%20style%20manhwa%20cover%20art&width=400&height=560&seq=webtoon-cover-03&orientation=portrait",
    description: "首尔连续发生多起离奇失踪案件，刑警金泰浩在调查过程中发现了一个隐藏在城市暗处的庞大犯罪网络。每一个看似无关的线索都指向同一个方向，而真相远比想象中更加骇人。他必须在下一个受害者出现之前找到突破口，而身边的人似乎也不能完全相信。这是一场与时间和黑暗的赛跑。",
    rating: 9.6,
    views: "890万",
    status: "已完结",
    tags: ["悬疑", "犯罪", "推理"],
    featured: true,
    chapters: [
      { id: 301, title: "第1话 - 失踪的夜晚", number: 1, date: "2024-03-01" },
      { id: 302, title: "第2话 - 第一个线索", number: 2, date: "2024-03-08" },
      { id: 303, title: "第3话 - 迷雾重重", number: 3, date: "2024-03-15" },
      { id: 304, title: "第4话 - 逼近的真相", number: 4, date: "2024-03-22" },
      { id: 305, title: "第5话 - 最终对决", number: 5, date: "2024-03-29" },
    ],
  },
  {
    id: 4,
    title: "爆笑学院日常",
    author: "崔敏秀",
    category: "comedy",
    cover: "https://readdy.ai/api/search-image?query=A%20funny%20Korean%20webtoon%20style%20illustration%20of%20four%20high%20school%20students%20making%20silly%20faces%20and%20laughing%20together%20in%20a%20classroom%20bright%20colorful%20comic%20style%20with%20exaggerated%20expressions%20playful%20atmosphere%20chibi%20style%20manhwa%20cover&width=400&height=560&seq=webtoon-cover-04&orientation=portrait",
    description: "四个性格迥异的高中生在同一个班级里发生的爆笑日常。有爱耍宝的班长、永远睡不醒的学霸、莽撞的热血少年和毒舌的美术天才。他们在平凡的高中生活中制造出不平凡的笑料，每一页都让人捧腹大笑。这里有最纯粹的友情和最无厘头的搞笑，让你在忙碌的生活中找到最简单的快乐。",
    rating: 9.3,
    views: "1680万",
    status: "连载中",
    tags: ["搞笑", "校园", "日常"],
    latest: true,
    chapters: [
      { id: 401, title: "第1话 - 开学第一天", number: 1, date: "2024-07-01" },
      { id: 402, title: "第2话 - 班长的野心", number: 2, date: "2024-07-08" },
      { id: 403, title: "第3话 - 体育课的灾难", number: 3, date: "2024-07-15" },
      { id: 404, title: "第4话 - 食堂大作战", number: 4, date: "2024-07-22" },
    ],
  },
  {
    id: 5,
    title: "血月传说",
    author: "郑宇成",
    category: "horror",
    cover: "https://readdy.ai/api/search-image?query=A%20horror%20Korean%20webtoon%20style%20illustration%20of%20a%20creepy%20abandoned%20mansion%20under%20a%20blood%20red%20moon%20shadowy%20figure%20at%20the%20window%20dark%20eerie%20atmosphere%20with%20bare%20tree%20branches%20silhouette%20gothic%20horror%20manhwa%20cover%20style%20chilling%20mood&width=400&height=560&seq=webtoon-cover-05&orientation=portrait",
    description: "在一个被诅咒的小镇上，每当血月升起时就会有人神秘消失。转学生尹智恩搬到这里的第一天就感受到了异样——镇民们的眼神、古老的禁忌、以及那栋被称为「禁地」的废弃宅邸。随着血月之夜越来越近，智恩发现自己与这个诅咒有着不可割舍的联系。真相令人毛骨悚然，而逃避已经不再是一个选项。",
    rating: 9.1,
    views: "720万",
    status: "连载中",
    tags: ["恐怖", "超自然", "惊悚"],
    latest: true,
    chapters: [
      { id: 501, title: "第1话 - 陌生的新家", number: 1, date: "2024-07-05" },
      { id: 502, title: "第2话 - 镇上的秘密", number: 2, date: "2024-07-12" },
      { id: 503, title: "第3话 - 第一个血月", number: 3, date: "2024-07-19" },
    ],
  },
  {
    id: 6,
    title: "武神降临",
    author: "姜东元",
    category: "action",
    cover: "https://readdy.ai/api/search-image?query=A%20action%20Korean%20webtoon%20style%20illustration%20of%20a%20martial%20arts%20warrior%20with%20flowing%20dark%20hair%20in%20dynamic%20fighting%20pose%20energy%20aura%20surrounding%20him%20ancient%20Korean%20palace%20in%20background%20epic%20battle%20scene%20dramatic%20composition%20manhwa%20cover%20art&width=400&height=560&seq=webtoon-cover-06&orientation=portrait",
    description: "曾经统治武林的第一高手朴武真，在一次阴谋中跌落悬崖。所有人都以为他已经死了，但十七年后，他以一个普通人的身份重新出现。然而平静的生活并没有持续太久，当年的仇人找上门来。为了保护现在的家人，他必须重拾失落的武功，面对那段他不愿回忆的过去。一场席卷整个武林的暴风雨即将来临。",
    rating: 9.7,
    views: "3100万",
    status: "连载中",
    tags: ["动作", "武侠", "复仇"],
    featured: true,
    latest: true,
    chapters: [
      { id: 601, title: "第1话 - 坠崖", number: 1, date: "2024-04-10" },
      { id: 602, title: "第2话 - 十七年后", number: 2, date: "2024-04-17" },
      { id: 603, title: "第3话 - 不速之客", number: 3, date: "2024-04-24" },
      { id: 604, title: "第4话 - 重拾武学", number: 4, date: "2024-05-01" },
      { id: 605, title: "第5话 - 山雨欲来", number: 5, date: "2024-05-08" },
      { id: 606, title: "第6话 - 首次对决", number: 6, date: "2024-05-15" },
      { id: 607, title: "第7话 - 势如破竹", number: 7, date: "2024-05-22" },
    ],
  },
  {
    id: 7,
    title: "心动便利店",
    author: "赵恩静",
    category: "romance",
    cover: "https://readdy.ai/api/search-image?query=A%20sweet%20Korean%20webtoon%20style%20illustration%20of%20a%20young%20couple%20smiling%20at%20each%20other%20inside%20a%20cozy%20convenience%20store%20at%20night%20warm%20yellow%20lighting%20shelves%20of%20snacks%20in%20background%20gentle%20romantic%20atmosphere%20manhwa%20cover%20style&width=400&height=560&seq=webtoon-cover-07&orientation=portrait",
    description: "大学新生金多美为了赚取生活费，在社区便利店里做起了夜班兼职。本以为会是一段平淡无奇的打工经历，却遇到了每晚都会来买同一种零食的神秘学长。从最初的简单问候，到后来的深夜谈心，这家小小的便利店成了他们爱情故事的起点。生活中最不起眼的角落，往往藏着最动人的缘分。",
    rating: 9.4,
    views: "1950万",
    status: "已完结",
    tags: ["恋爱", "校园", "治愈"],
    latest: true,
    chapters: [
      { id: 701, title: "第1话 - 夜班第一天", number: 1, date: "2024-02-14" },
      { id: 702, title: "第2话 - 草莓牛奶", number: 2, date: "2024-02-21" },
      { id: 703, title: "第3话 - 雨夜的客人", number: 3, date: "2024-02-28" },
      { id: 704, title: "第4话 - 心动的开始", number: 4, date: "2024-03-06" },
      { id: 705, title: "第5话 - 告白之夜", number: 5, date: "2024-03-13" },
    ],
  },
  {
    id: 8,
    title: "人生重启计划",
    author: "林在范",
    category: "drama",
    cover: "https://readdy.ai/api/search-image?query=A%20drama%20Korean%20webtoon%20style%20illustration%20of%20a%20young%20man%20looking%20at%20his%20reflection%20in%20a%20mirror%20showing%20two%20different%20versions%20of%20himself%20office%20worker%20and%20artist%20emotional%20conflict%20warm%20but%20melancholic%20tone%20manhwa%20cover%20art&width=400&height=560&seq=webtoon-cover-08&orientation=portrait",
    description: "三十岁的张贤宇过着令人羡慕的生活——大企业科长、稳定收入、体面社会地位。但在某个加班到凌晨的夜晚，他突然问自己：这就是我想要的人生吗？曾经梦想成为画家的他，做出了一个疯狂的决定——辞职，重新开始。面对家人的反对和朋友的质疑，他能否在三十岁这个年纪找回真正的自己？",
    rating: 9.5,
    views: "1360万",
    status: "连载中",
    tags: ["剧情", "人生", "励志"],
    chapters: [
      { id: 801, title: "第1话 - 凌晨三点的疑问", number: 1, date: "2024-06-10" },
      { id: 802, title: "第2话 - 递交辞呈", number: 2, date: "2024-06-17" },
      { id: 803, title: "第3话 - 家人的反对", number: 3, date: "2024-06-24" },
      { id: 804, title: "第4话 - 画布上的第一笔", number: 4, date: "2024-07-01" },
    ],
  },
  {
    id: 9,
    title: "萌宠咖啡馆",
    author: "韩素拉",
    category: "slice-of-life",
    cover: "https://readdy.ai/api/search-image?query=A%20heartwarming%20Korean%20webtoon%20style%20illustration%20of%20a%20cozy%20cat%20cafe%20with%20various%20cute%20cats%20and%20a%20smiling%20female%20owner%20behind%20the%20counter%20soft%20sunlight%20streaming%20through%20windows%20plants%20and%20wooden%20furniture%20warm%20pastel%20colors%20manhwa%20cover&width=400&height=560&seq=webtoon-cover-09&orientation=portrait",
    description: "因工作压力而身心俱疲的平面设计师柳夏恩，在朋友的推荐下来到一家猫咪咖啡馆。在这里她不仅找回了内心的平静，还结识了一群有着各自故事的常客。从退休的退伍军人到内向的高中生，每个人都在这些毛茸茸的小生灵身上找到了慰藉。这是一个关于治愈、温暖和人与人之间奇妙缘分的故事。",
    rating: 9.0,
    views: "680万",
    status: "连载中",
    tags: ["日常", "治愈", "萌宠"],
    chapters: [
      { id: 901, title: "第1话 - 推开那扇门", number: 1, date: "2024-07-08" },
      { id: 902, title: "第2话 - 猫与陌生人", number: 2, date: "2024-07-15" },
      { id: 903, title: "第3话 - 常客们", number: 3, date: "2024-07-22" },
    ],
  },
  {
    id: 10,
    title: "末日生存法则",
    author: "金泰亨",
    category: "action",
    cover: "https://readdy.ai/api/search-image?query=A%20post%20apocalyptic%20Korean%20webtoon%20style%20illustration%20of%20a%20survivor%20in%20tattered%20clothes%20holding%20a%20weapon%20standing%20on%20a%20destroyed%20city%20rooftop%20orange%20sunset%20sky%20ruined%20buildings%20behind%20him%20dramatic%20epic%20composition%20action%20manhwa%20cover&width=400&height=560&seq=webtoon-cover-10&orientation=portrait",
    description: "一夜之间，世界陷入了混乱。病毒爆发让大部分人类变成了疯狂的怪物，幸存者们必须在残垣断壁中挣扎求生。前特种兵李正勋带领着一群性格迥异的幸存者，在末日废墟中寻找安全的栖身之所。但他们很快发现，有时候最大的威胁并非来自变异的怪物，而是那些同样幸存下来的——人类。",
    rating: 9.6,
    views: "2750万",
    status: "连载中",
    tags: ["动作", "末日", "生存"],
    featured: true,
    chapters: [
      { id: 1001, title: "第1话 - 爆发", number: 1, date: "2024-05-20" },
      { id: 1002, title: "第2话 - 集结", number: 2, date: "2024-05-27" },
      { id: 1003, title: "第3话 - 第一个夜晚", number: 3, date: "2024-06-03" },
      { id: 1004, title: "第4话 - 内部分裂", number: 4, date: "2024-06-10" },
      { id: 1005, title: "第5话 - 希望的信号", number: 5, date: "2024-06-17" },
      { id: 1006, title: "第6话 - 生死抉择", number: 6, date: "2024-06-24" },
    ],
  },
  {
    id: 11,
    title: "魔法学园奇谭",
    author: "申艺琳",
    category: "fantasy",
    cover: "https://readdy.ai/api/search-image?query=A%20magical%20Korean%20webtoon%20style%20illustration%20of%20students%20in%20a%20magic%20academy%20wearing%20robes%20casting%20colorful%20spells%20floating%20books%20and%20magical%20creatures%20grand%20castle%20interior%20vibrant%20fantasy%20manhwa%20cover%20style&width=400&height=560&seq=webtoon-cover-11&orientation=portrait",
    description: "在隐藏于现代都市之下的魔法学园里，来自普通家庭的新生文素美发现自己是罕见的「元素共鸣者」。这意味着她能同时操控两种以上的魔法元素。然而这个天赋既是祝福也是诅咒，因为上一个拥有这种能力的人最终导致了学园的毁灭。素美必须在同学们异样的眼光中证明自己，同时调查那个尘封百年的真相。",
    rating: 9.3,
    views: "1520万",
    status: "连载中",
    tags: ["奇幻", "校园", "魔法"],
    chapters: [
      { id: 1101, title: "第1话 - 录取通知书", number: 1, date: "2024-06-05" },
      { id: 1102, title: "第2话 - 进入学园", number: 2, date: "2024-06-12" },
      { id: 1103, title: "第3话 - 元素觉醒", number: 3, date: "2024-06-19" },
      { id: 1104, title: "第4话 - 隐藏的预言", number: 4, date: "2024-06-26" },
    ],
  },
  {
    id: 12,
    title: "办公室罗曼史",
    author: "张美英",
    category: "romance",
    cover: "https://readdy.ai/api/search-image?query=A%20romantic%20office%20Korean%20webtoon%20style%20illustration%20of%20a%20handsome%20male%20colleague%20and%20a%20beautiful%20female%20colleague%20sharing%20coffee%20in%20a%20modern%20office%20breakroom%20subtle%20romantic%20tension%20elegant%20clean%20art%20style%20manhwa%20cover&width=400&height=560&seq=webtoon-cover-12&orientation=portrait",
    description: "在首尔最顶尖的广告公司里，创意总监姜河那和新来的文案策划安秀晶因为一个项目被迫合作。姜河那是个完美主义者，而安秀晶则充满天马行空的创意。起初的摩擦和冲突在工作推进中逐渐转变为默契与欣赏。然而公司明令禁止办公室恋情，两个人能否在事业与感情之间找到平衡？",
    rating: 9.1,
    views: "1080万",
    status: "已完结",
    tags: ["恋爱", "职场", "都市"],
    chapters: [
      { id: 1201, title: "第1话 - 新来的文案", number: 1, date: "2024-04-01" },
      { id: 1202, title: "第2话 - 针锋相对", number: 2, date: "2024-04-08" },
      { id: 1203, title: "第3话 - 深夜加班", number: 3, date: "2024-04-15" },
      { id: 1204, title: "第4话 - 心照不宣", number: 4, date: "2024-04-22" },
    ],
  },
];

export const siteInfo = {
  name: "韩漫网",
  description: "韩漫网是在线免费阅读韩国漫画的首选平台，提供海量韩漫资源、及时更新和优质阅读体验。无论您喜欢恋爱、奇幻、动作还是悬疑题材，都能在这里找到心仪的韩国漫画。",
  keywords: "在线韩漫,免费阅读韩国漫画,韩漫大全,韩漫网",
  url: "https://qmss2.cn",
  foundingYear: "2020",
};

export const aboutInfo = {
  brandIntro: "韩漫网成立于2020年，是国内领先的韩国漫画在线阅读平台。我们致力于为广大漫画爱好者提供便捷、优质、免费的韩国漫画阅读服务。经过多年的积累与发展，韩漫网已经成为国内最受欢迎的韩漫阅读平台之一。",
  mission: "我们的使命是打破语言和地域的障碍，让每一位中文读者都能轻松享受韩国漫画的魅力。我们与多家韩国漫画平台和创作者建立了合作关系，确保第一时间为读者带来最新、最全的韩国漫画资源。",
  values: [
    { title: "资源齐全", description: "涵盖恋爱、奇幻、动作、悬疑、搞笑、恐怖等多种类型的韩国漫画，满足不同读者的阅读需求。" },
    { title: "更新及时", description: "与韩国同步更新，确保读者不错过任何一话精彩内容，追更无需漫长等待。" },
    { title: "免费阅读", description: "坚持免费阅读理念，让每一位漫画爱好者都能无门槛享受优质的漫画内容。" },
    { title: "优质体验", description: "简洁清爽的界面设计，流畅的加载速度，支持多设备自适应浏览，打造极致阅读体验。" },
  ],
  reputation: [
    { metric: "500万+", label: "月活跃用户" },
    { metric: "10000+", label: "漫画资源" },
    { metric: "98%", label: "用户好评率" },
    { metric: "50+", label: "合作平台" },
  ],
  contact: {
    email: "contact@hanmanwang.com",
    wechat: "hanmanwang2020",
    weibo: "@韩漫网官方",
    address: "北京市朝阳区望京SOHO T2-B座 1806室",
    phone: "400-888-6666",
  },
};